import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import clsx from "clsx";
import styles from "../../../../pages/shops/index.module.scss";
import Sldier from "../../../common/slider";
import Adv from "../../../main/adv";
import Maper from "../../contacts/maper";
import { getPictureOrigById } from "../../../../utils";

export default function ShopDetail({ shop }) {
  const { shopReviews } = useSelector((state) => state.content);
  const images = useMemo(() => {
    return shop.data.photos.map((id) => {
      const path = getPictureOrigById(id, "shops");
      return {
        thumb: path,
        full: path,
      };
    });
  }, [shop]);

  const reviewsFiltered = useMemo(() => {
    return shopReviews.filter((review) => {
      return shop.name.includes(review.PROPERTY_CITYS_VALUE);
    });
  }, [shopReviews, shop]);

  const [pointId, setPointId] = useState(null);

  const { shops } = useSelector((state) => state.contacts);

  const shopPoint = shops.find((currentShop) => currentShop.page === shop.id);

  return (
    <div className={styles.Blocks}>
      <h1>{shop.name}</h1>
      {shopPoint.directionsScheme && (
        <div
          className={styles.SchemeTop}
          onClick={() => {
            const selector = document.getElementById("map");
            window.scrollTo({
              top: selector.offsetTop + 100,
              behavior: "smooth",
            });
            setPointId(shopPoint.id);
          }}
        >
          Схема проезда
        </div>
      )}
      <div className={styles.Images}>
        <Sldier images={images} />
      </div>
      <div className={styles.Adreses}>
        <div className={styles.Adr}>
          <div className={styles.AdrBlock}>
            {shopPoint.directionsScheme && (
              <div
                className={clsx(styles.Scheme, styles.SchemeSelected)}
                onClick={() => setPointId(shopPoint.id)}
              >
                Схема проезда
              </div>
            )}
            <div>Адрес:</div>
            <span>{shopPoint.name}</span>
            {shopPoint.workingHours && (
              <>
                <div>Режим работы:</div>
                <span>{shopPoint?.workingHours}</span>
              </>
            )}
          </div>
        </div>
        <div className={styles.Map} id="map">
          <Maper zoom={9} points={[shopPoint]} pointId={pointId} />
        </div>
      </div>
      <div className={styles.Adv}>
        <h2>Наши преимущества</h2>
        <Adv rows={2} />
      </div>
      {shop.data.videoLink && (
        <div className={styles.Video}>
          <h2>Видео магазина</h2>
          <iframe src={shop.data.videoLink}></iframe>
        </div>
      )}
      <div>
        {reviewsFiltered.map((review) => (
          <>
            {review.PROPERTY_TYPE_VALUE === "Кнопка" && (
              <a
                href={review.PROPERTY_LINK_VALUE}
                target="_blank"
                rel="noreferrer"
                key={review.ID}
                className={styles.Button}
              >
                <div className={styles.Img}>
                  <img src={review.ICON_SRC} />
                </div>
                <div className={styles.Name}>{review.NAME}</div>
                <div className={styles.Qnt}>
                  Количество отзывов: {review.PROPERTY_COUNT_VALUE}
                </div>
                <div className={styles.Rating}>
                  <div className="video-sources-block__rating-val">
                    {review.PROPERTY_RATING_VALUE}
                  </div>
                </div>
              </a>
            )}
            {review.PROPERTY_TYPE_VALUE === "Виджет" && (
              <div className={styles.Item} key={review.ID}>
                <h3>{review.NAME}</h3>
                <div
                  className={styles.Frame}
                  dangerouslySetInnerHTML={{ __html: review["~PREVIEW_TEXT"] }}
                />
              </div>
            )}
          </>
        ))}
      </div>
      <div className={styles.Requisite}>
        <div dangerouslySetInnerHTML={{ __html: shop.data.content }} />
      </div>
    </div>
  );
}
